<template>
    <div>

        <vue-headful title="MeritEHS Accounts :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-key"></i> MeritEHS Accounts</li>
                <li class="ml-3">
                    <router-link :to="`/dev/accounts/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create Account</router-link>
                </li>
            </ol>
        </h4>
        <hr />
        <div class="card">
            <div class="card-body">
                <v-server-table ref="obsTable" url="/dev/accounts/list" :columns="columns" :options="options">

                    <router-link slot="SmartBizClientId" slot-scope="props" :to="`/dev/accounts/view/${props.row.SmartBizClientId}`" title="View Account" class="btn btn-sm btn-light">
                        View - {{ props.row.SmartBizClientId }}
                    </router-link>

                    <router-link slot="ClientName" slot-scope="props" :to="`/dev/accounts/view/${props.row.SmartBizClientId}`" title="View Account">
                        {{ props.row.ClientName }}
                    </router-link>

                    <template slot="created_at" slot-scope="props">
                        {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm a") }}
                    </template>

                    <template slot="trial_ends_at" slot-scope="props">
                        {{ props.row.trial_ends_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm a") }}
                    </template>

                    <template slot="prepaid_date_ends_at" slot-scope="props">
                        <span v-if="props.row.prepaid_date_ends_at">{{ props.row.prepaid_date_ends_at | moment("MM/DD/YYYY") }}</span>
                    </template>

                    <template slot="prepaid_nbr_users" slot-scope="props">
                        <span v-if="props.row.prepaid_nbr_users > 0">{{ props.row.prepaid_nbr_users }}</span>
                    </template>

                    <template slot="IsActive" slot-scope="props">
                        <span class="badge badge-success" v-if="props.row.IsActive == 1">Active</span>
                        <span class="badge badge-warning" v-else>Inactive</span>
                    </template>

                    <template slot="has_paid" slot-scope="props">
                        <span class="badge badge-success" v-if="props.row.has_paid == 1">Paying</span>
                        <span class="badge badge-danger" v-else>Not Paying</span>
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                exportingTable: false,
                userTimezone: this.$store.state.user.timezone,
                userFilterId: {},
                columns: ['SmartBizClientId', 'ClientName', 'created_at', 'trial_ends_at', 'prepaid_nbr_users', 'prepaid_nbr_action_users', 'IsActive', 'has_paid'],
                options: {
                    headings: {
                        SmartBizClientId: 'ID',
                        ClientName: 'Name',
                        created_at: 'Created',
                        trial_ends_at: 'Trial Ends At',
                        prepaid_nbr_users: 'Standard Licenses',
                        prepaid_nbr_action_users: 'Corrective Action Licenses',
                        IsActive: 'Active',
                        has_paid: 'Paying',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'trial_ends_at',
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'SmartBizClientId',
                },
            }
        },

        methods: {

        },
    }
</script>
